module.exports = __webpack_public_path__ + "img/aws.25101048.jpg";